import {useInfiniteQuery} from '@tanstack/react-query';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';
import {getFaqSearchList} from '@/api/help';
import {getNextPageNo} from '@/utils/help';
import {UseGetFaqListInfinityResult} from './useGetFaqListInfinity';

interface UseGetFaqSearchListInfinityProps {
  limit?: number;
  searchWord: string;
}

export const useGetFaqSearchListInfinity = ({
  limit,
  searchWord,
}: UseGetFaqSearchListInfinityProps): UseGetFaqListInfinityResult => {
  const {isMobile} = useHelpContext();

  return useInfiniteQuery({
    queryKey: ['help', 'faqSearch', 'infinity', limit, searchWord],
    queryFn: ({pageParam}) =>
      getFaqSearchList({limit, page: pageParam, searchWord}),
    select: ({pages}) => ({
      faqList: pages
        .map(({data}) =>
          data.faqList.map((item) => ({
            ...item,
            title: item.title.replace(/&#32;/g, ''), // 공백 문자 변환
          })),
        )
        .flat(),
      count: pages[pages.length - 1].data.faqCount,
    }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      getNextPageNo(lastPage.data?.pageNo, lastPage.data?.faqCount),
    enabled: isMobile && !!searchWord,
  });
};
